import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { VueEditor } from 'vue2-editor'
import { api, auth } from '@/f1/service';
import codes from '@/f1/codes';


const _i18n_data = {
  saved: {
    EN : `saved`,
    KO : `저장되었습니다`,
  },
  updated: {
    EN : `updated`,
    KO : `업데이트되었습니다`,
  },
  removed: {
    EN : `removed`,
    KO : `삭제되었습니다`,
  },
};

export default {
  components: {
    VueEditor,
    cSwitch,
    vSelect,
  },
  data : () => ({
    codes,
    editor: null,
    auth,
    confirm: false,
    add: false,
    lock: true,
    model : {},
    allowed: false,
  }),
  computed: {
    i18n_data() { return _i18n_data },
    last_info() { return `${this.$options.filters.sdate(this.model.last_visit)} @ ${this.model.last_addr}`; }
  },
  methods: {
    cancel() { this.$router.replace({ name: 'qna', params: { id: this.model.id }}); },
    edit() { this.$router.replace({ name: 'qna', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        let rs = await api.board.Board_Call('qna', 'delete', { id : this.model.id });
        if(rs.error) {
          return this.$toastr.e("delete failed")
        }
        this.$parent.$emit('refresh'); this.$toastr.s(this.i18n_data['removed'][this.i18n]);
        this.list();
      } catch(e) { this.$toastr.e(e.data.message || e); this.list(); }
    },
    back() { this.list() },
    list() { this.$router.push({ name: 'qna'}); },
    async save() {
      if(!(this.model.type || '').trim()) { return this.$toastr.e('Type required.'); }
      if(!(this.model.title || '').trim()) { return this.$toastr.e('Title required.'); }
      if(!(this.model.question || '').trim()) { return this.$toastr.e('Question required.'); }
      try {
        if(this.model.id) {
          let rs = await api.board.Board({ target : 'qna', cmd : 'update', body : this.model});
          if(rs.error) { return this.$toastr.e("update failed") }
        } else {
          let rs = await api.board.Board({ target : 'qna', cmd : 'insert', body : this.model})
          if(rs.error) { return this.$toastr.e("registed failed") }
          this.$router.push({ name: 'qna', params : { id: rs.body.id } })
        }
        this.$toastr.s('Done.');
        this.list();
        this.$parent.$emit('refresh');
      } catch(e) { this.$toastr.e(e.data || e); this.cancel(); }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      this.editor ? this.editor.destroy() : ''

      console.log('[vue] qna.detail', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model = Object.assign({}); return; }
      else { this.add = false; }

      this.lock = (tag !== 'edit');

      try {
        let rs = await api.board.Board_Call('qna', 'detail', { id : id });
        if(rs.error) { return this.$toastr.e("load failed") }
        this.model = rs.body
        // this.editor = new Editor({ content : this.model.question })
      } catch(e) { console.log(e); this.$toastr.e(e.data || e); this.list(); }

    }
  },
  watch: { '$route' (to, from) { this.get(to.params); } },
  created() { console.log('[vue] qna.detail', 'created'); },
  destroyed() { console.log('[vue] qna.detail', 'destroyed'); },
  mounted() {
    console.log('[vue] qna.detail', 'mounted');
    this.get(this.$route.params);
  },
}
